// Importing necessary libraries and components
import React from "react";
import ClickAwayListener from "@material-ui/core/ClickAwayListener"; // Detects clicks outside the component
import TextField from "@material-ui/core/TextField"; // Material-UI text input field
import PropTypes from "prop-types"; // For type-checking props
import Collapse from "@material-ui/core/Collapse"; // For collapsible UI elements
import { makeStyles } from "@material-ui/core/styles"; // For custom styling
import Grid from "@material-ui/core/Grid"; // For grid layout
import tableStyle from "../../assets/jss/material-dashboard-react/components/reportTables"; // Custom styles

// Functional component to render search fields
const SearchFields = ({
  searchBar, // Boolean to control the visibility of the search bar
  Fields, // Component to render inside the collapsible search bar
  handleSearchClose, // Function to handle closing the search bar
  handleSearchOpen, // Function to handle opening the search bar
  searchValue, // Current search text
  handleSearchChange = () => {}, // Function to handle search text changes
  placeholder = "", // Placeholder text for the search input
}) => {
  const useStyles = makeStyles(tableStyle); // Apply custom styles
  const classes = useStyles(); // Access the generated classes
  const searchInputProps = searchValue !== undefined ? { value: searchValue } : {};

  return (
    <>
      {/* Detect clicks outside the search bar to close it */}
      <ClickAwayListener
        mouseEvent="onMouseDown"
        touchEvent="onTouchStart"
        onClickAway={() => handleSearchClose()}
      >
        <Grid style={{ width: "30%", marginRight: "25px" }}>
          {/* TextField to trigger the search bar */}
          <TextField
            onClick={() => handleSearchOpen()} // Open the search bar on click
            style={{ display: "flex" }}
            {...searchInputProps}
            onChange={handleSearchChange}
            placeholder={placeholder}
            InputLabelProps={{
              classes: {
                root: classes.activeInputLableColor, // Custom label color
                focused: "focused", // Focused state styling
              },
            }}
            InputProps={{
              classes: {
                root: classes.activeInputColor, // Custom input color
                input: classes.resize, // Custom input size
                focused: "focused", // Focused state styling
              },
            }}
            label="Search" // Label for the input field
          />

          {/* Collapsible container for additional search fields */}
          <Collapse
            in={searchBar} // Controls visibility of the collapsible section
            timeout="auto" // Animation timeout
            unmountOnExit // Unmount the component when collapsed
            className={classes.overLayBox} // Custom overlay styling
            style={{ width: "26.5%" }}
          >
            <Fields />
{" "}
{/* Render the Fields component */}
          </Collapse>
        </Grid>
      </ClickAwayListener>
    </>
  );
};

// Defining prop types for the component
SearchFields.propTypes = {
  searchBar: PropTypes.bool, // Boolean to control visibility of the search bar
  Fields: PropTypes.any, // Component to render inside the collapsible section
  handleSearchClose: PropTypes.func, // Function to handle closing the search bar
  handleSearchOpen: PropTypes.func, // Function to handle opening the search bar
  searchValue: PropTypes.string,
  handleSearchChange: PropTypes.func,
  placeholder: PropTypes.string,
};

// Exporting the component as the default export
export default SearchFields;




